import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Link from "../../Link";

import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

function ProductCard({
  image,
  uri,
  title,
  children,
  onSale,
  backgroundColor,
  backgroundImage,
}) {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      {onSale && <span className={classes.offer}>Offer</span>}
      <div
        className={classes.upper}
        style={{
          backgroundColor: backgroundColor || "#A6C46E",
          backgroundImage: `url('${backgroundImage}')`,
        }}
      >
        <h2 className={classes.header}>{title}</h2>
        <img className={classes.image} src={image} alt={title} />
      </div>
      <div className={classes.lower}>
        {children}
        <Link className={classes.cta} to={uri}>
          Discover More
        </Link>
      </div>
    </div>
  );
}

export default ProductCard;
